var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_c('a',{staticClass:"float-right crsr-pointer",on:{"click":function($event){return _vm.$emit('cleared')}}},[_vm._v("x")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }